{
	"importingPhotos": "Importing photos... {{completed}}/{{total}}",
	"doNotClose": "Do not close this browser window, it will cancel import"
}
